import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0E2A1A] text-[#FFFFFF] pt-16 md:pt-24 pb-8"
    >
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        {/* Massive wordmark */}
        <div className="pb-16 md:pb-24 overflow-hidden">
          <div
            className="font-display text-[22vw] sm:text-[18vw] md:text-[15vw] leading-[0.86] tracking-[-0.035em] text-[#FFFFFF] italic"
            style={{ fontWeight: 400 }}
          >
            El <span className="text-[#DA7B3C]">Monos</span>
          </div>
          <div className="mt-4 flex flex-wrap items-baseline gap-x-5 gap-y-2 font-mono-sm text-[#FFFFFF]/60">
            <span>Landscaping</span>
            <span className="text-[#DA7B3C]">·</span>
            <span>Lawn Care</span>
            <span className="text-[#DA7B3C]">·</span>
            <span>Junk Removal</span>
            <span className="text-[#DA7B3C]">·</span>
            <span>Bobcat Services</span>
            <span className="text-[#DA7B3C]">·</span>
            <span>LLC</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12">
          <div className="md:col-span-5">
            <div className="font-mono-sm text-[#DA7B3C] mb-4">About</div>
            <p className="text-[#FFFFFF]/75 leading-relaxed max-w-md text-base">
              {"Family-run landscaping, lawn care, junk removal, bobcat, and haul-off serving San Antonio and surrounding areas for over 25 years."}
            </p>

            {/* SEO service-area content */}
            <div className="mt-10">
              <div className="font-mono-sm text-[#DA7B3C] mb-4">
                Service Areas
              </div>
              <p className="text-[#FFFFFF]/55 text-sm leading-relaxed max-w-md">
                Proudly serving San Antonio, Alamo Heights, Stone Oak, Helotes,
                Boerne, Schertz, Timberwood Park, Converse, Live Oak, Universal
                City, Cibolo, Selma, Leon Valley, and the greater Bexar County
                area with professional landscaping, lawn care, junk removal,
                bobcat services, lot clearing, gravel driveways, grading, and
                demolition.
              </p>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-sm text-[#DA7B3C] mb-4">Navigate</div>
            <ul className="space-y-2 text-sm">
              {[
                { l: "Services", h: "#services" },
                { l: "Our Work", h: "#work" },
                { l: "Process", h: "#how" },
                { l: "About", h: "#why" },
                { l: "Get a Quote", h: "#quote" },
              ].map((x) => (
                <li key={x.h}>
                  <a
                    href={x.h}
                    className="text-[#FFFFFF]/80 hover:text-[#DA7B3C] transition-colors inline-flex items-center gap-2 group"
                  >
                    <span className="w-3 h-px bg-current opacity-0 group-hover:opacity-100 transition-opacity" />
                    {x.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-sm text-[#DA7B3C] mb-4">Contact</div>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href={`tel:${BRAND.phoneRaw}`}
                  data-testid="footer-phone"
                  className="inline-flex items-center gap-3 text-[#FFFFFF] hover:text-[#DA7B3C] group"
                >
                  <Phone className="w-4 h-4" strokeWidth={1.75} />{" "}
                  {BRAND.phone}
                  <ArrowUpRight
                    className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity"
                    strokeWidth={2}
                  />
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-3 text-[#FFFFFF] hover:text-[#DA7B3C] break-all group"
                >
                  <Mail className="w-4 h-4 shrink-0" strokeWidth={1.75} />{" "}
                  <span>{BRAND.email}</span>
                </a>
              </li>
              <li className="text-[#FFFFFF]/70 pt-2 border-t border-[#FFFFFF]/10">
                {BRAND.hours}
              </li>
              <li className="text-[#FFFFFF]/70">
                {BRAND.city} & surrounding
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-[#FFFFFF]/15 flex flex-col sm:flex-row items-center justify-between gap-4 font-mono-sm text-[#FFFFFF]/50">
          <div>
            © {year} El Monos Landscaping & Junk Removal LLC · San Antonio, TX
          </div>
          <div className="flex items-center gap-3">
            <span className="text-[#DA7B3C]">✦</span>
            Licensed & Insured
            <span className="text-[#DA7B3C]">✦</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
